import { ErrorMessage } from "formik";

const CustomTextArea = ({
  field,
  form: { touched, errors },
  label,
  placeholder,
  required,
  noMarginBottom,
  ...props
}) => {
  return (
    <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
      {label && (
        <label className="mb-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <textarea
        {...field}
        {...props}
        placeholder={placeholder}
        // invalid={touched[field.name] && !!errors[field.name]}
        // valid={touched[field.name] && !errors[field.name]}
        autoComplete={"off"}
        className="form-control form-control-sm"
      />

      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomTextArea;
